module.exports = __webpack_public_path__ + "static/img/logo.96e05dad.svg";